import { AxiosInstance } from "axios";
import CommonCRUD from "modules/CommonCRUD";

class CustomersSubdivisions extends CommonCRUD {}

export default CustomersSubdivisions;
